/**
 * セクション見出し右のインラインアクション（＋追加 / ↗ビュー 等）の共通形（②小チップ）。
 * `<button>`/`<label>` どちらにも付けられるよう className を共有する。色は役割で付け足す
 * （遷移＝text-interactive-active・変更＝text-text-secondary）。
 */
export const inlineActionClass =
    "cursor-pointer rounded border border-border-subtle bg-surface px-2 py-0.5 text-xs hover:bg-sidebar-bg disabled:opacity-40";

/**
 * リストに項目を追加する全幅ブロックボタンの共通形（破線枠＋＋アイコン）。リスト直上に置く。
 * `<button>`/`<label>`（FilePickerButton）どちらにも付けられるよう className を共有し、
 * アイコン＋ラベルを中央寄せする（gap-1）。アドイン・Webコンソールで同一表示にするための単一所有。
 */
export const addBlockClass =
    "flex w-full cursor-pointer items-center justify-center gap-1 rounded border border-dashed border-border-subtle px-2.5 py-1 text-xs text-interactive transition-colors hover:border-interactive hover:bg-interactive/5 disabled:opacity-40";
